<template>
  <div class="paymentPage">
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="baseData.reason"
        rows="1"
        autosize
        :required="editType"
        label="付款事由："
        type="textarea"
        placeholder="请输入...  "
        :readonly="!editType"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary beizhu">
      <van-field
       rows="1"
          autosize
          type="textarea"
        :required="editType"
        v-model="baseData.collectingCompany"
        placeholder="请输入...  "
        :readonly="!editType"
        class="ggInput"
        label="收款单位："
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        :required="editType"
        v-model="baseData.paymentTypeName"
        placeholder="请选择"
        @click="showPaymentType"
        readonly
        :is-link="editType"
        class="ggInput"
        label="支付方式："
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary" v-if="baseData.paymentType == 'zz'">
      <van-field
        :required="editType"
        v-model="baseData.depositBank"
        placeholder="请输入...  "
        :readonly="!editType"
        class="ggInput"
        label="开户行："
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary" v-if="baseData.paymentType == 'zz'">
      <van-field
        :required="editType"
        v-model="baseData.bankAccount"
        placeholder="请输入...  "
        :readonly="!editType"
        class="ggInput"
        label="银行账户："
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        :required="editType"
        type="number"
        v-model="baseData.amount"
        placeholder="请输入...  "
        :readonly="!editType"
        class="ggInput"
        label="支付金额："
      />
    </van-cell-group>
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="baseData.remarks"
        rows="1"
        autosize
        label="备注"
        type="textarea"
        placeholder="请输入...  "
        :readonly="!editType"
      />
    </van-cell-group>

    <!-- 审批流程 -->
    <div class="approveList" v-if="this.mode != 'add' && baseData.verifyStatus!='hold'">
      <audit-list :applicantData="baseData"></audit-list>
    </div>

    <!-- 流程图 -->
    <div class="flowList" v-if="this.mode != 'add' && baseData.verifyStatus!='hold'">
       <flow-staff :applicantData="baseData"></flow-staff>
      <flow-list :workflowCode="baseData.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main :applicantData="baseData" @changeVerifyType="setVerifyType"></verify-main>
    </van-popup>

    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
      >提交</van-button>
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div class="btnBox editBtnbox clearfix" v-if="baseData.verifyStatus == 'hold'">
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              class="btn"
            >删除</van-button>
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              class="btn"
            >保存</van-button>
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="baseData.verifyStatus == 'deny' && mode != 'verify'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
        >再次提交</van-button>
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="baseData.verifyStatus == 'pending' && mode != 'verify'   && sendType!='1'"
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="rebackApply"
        class="btn"
      >撤回修改</van-button>
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="(mode=='verify' && baseData.verifyStatus=='pending'  &&  verifyType == '1') ||(mode=='verify' && baseData.verifyStatus=='doing'  &&  verifyType == '1') "
    >
      <van-button type="info" @click="verifyPage">{{verifyPageText}}</van-button>
    </div>
    <!-- 弹出框 -->
    <van-popup v-model="showPaymentTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="showPaymentTypeList"
        value-key="dictName"
        @cancel="showPaymentTypePicker = false"
        @confirm="savePaymentLevel"
      />
    </van-popup>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { isEdit } from "@/utils/common";
import { getDeviceType, closePage,is_wei} from "@/common/getDeviceType/getDeviceType";
const refreshPage = () => import("@/components/common/refreshPage");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
export default {
  name: "payment",
  components: {
    refreshPage,
    flowList,
    auditList,
    verifyMain,
    flowStaff
  },
  data() {
    return {
      mode: "add",
      editType: false, //能否编辑
      baseData: {
        amount: "", //申请原因
        bankAccount: "", //申请名称
        baseAnnexes: [],
        collectingCompany: "", //s收款单位
        depositBank: "", //开户银行
        paymentTypeName: "", //付款方式name
        paymentType: "", //付款方式code
        reason: "", //付款事由
        remarks: "", //备注
        verifyStatus: "hold"
      },
      showPaymentTypePicker: false, //转账方式弹框
      showPaymentTypeList: [
        {
          dictName: "转账",
          dictCode: "zz"
        },
        {
          dictName: "现金",
          dictCode: "xj"
        },
        {
          dictName: "汇票",
          dictCode: "hp",
        },
        {
          dictName: "保函",
          dictCode: "bh",
        },
      ], //转账方式列表
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
      sendType:"",//判断是否在抄送列表
      clientType: getDeviceType()
    };
  },
  mounted() {
    if(is_wei()){
      document.title="付款申请";
    }
    this.commonId = this.$route.query.commonId; //申请Id
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审批
     this.sendType =  this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //编辑页面
    this.$nextTick(() => {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      if (this.mode == "edit" || this.mode == "verify"|| this.mode == "view") {
        this.initPage();
      } else {
        this.setShowLoad(false);
      }
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    // 删除
    delApply() {
      let _this = this;
      this.$dialog
        .alert({
          title: "删除",
          message: "你确定删除吗?"
        })
        .then(() => {
          //请求接口
          _this.btnLoading = true;
          _this.$api.finance.payment
            .delete(this.commonId)
            .then(res => {
              if (res.code == 1) {
                let text = "删除操作成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch(() => {
              _this.$toast("网络失败，请稍后重试");
              _this.btnLoading = false;
            });
        });
    },
    // 撤回
    rebackApply() {
      let _this = this;
      this.$dialog
        .alert({
          title: "撤回",
          message: "你确定撤回吗?"
        })
        .then(() => {
          //请求接口
          _this.btnLoading = true;
          _this.$api.finance.payment
            .reback(this.commonId)
            .then(res => {
              if (res.code == 1) {
                let text = "撤回操作成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch(() => {
              _this.$toast("网络失败，请稍后重试");
              _this.btnLoading = false;
            });
        });
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    showPaymentType() {
      //判断当前是否编辑状态
      if (this.editType) {
        this.showPaymentTypePicker = true;
      }
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    savePaymentLevel(data) {
      this.showPaymentTypePicker = false;
      this.baseData.paymentTypeName = data.dictName;
      this.baseData.paymentType = data.dictCode;
    },
    initPage() {
      this.setShowLoad(false);
      let _this = this;
      // 接口详情
      _this.$api.finance.payment
        .details(_this.commonId)
        .then(res => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = newApi.assign({}, _this.baseData, res.data);
            _this.baseData.paymentTypeName =
              // _this.baseData.paymentType == "zz" ? "转账" : "现金";
              _this.baseData.paymentType == "zz" ? "转账" : _this.baseData.paymentType == "xj"?"现金":
              _this.baseData.paymentType == "hp"
                ? "汇票":"保函";
             if(_this.baseData.remarks==null){
               _this.baseData.remarks="";
             }
            if (
              (_this.baseData.verifyStatus == "hold" && _this.mode == "edit") ||
              (_this.baseData.verifyStatus == "deny" && _this.mode == "edit")
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            
              _this.$toast(res.msg);
           
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //保存
    checkInput() {
      let _this = this;
      if (this.validate()) {
        let params = this.baseData;
        _this.btnLoading = true;
        _this.$api.finance.payment
          .addEditPayment(this.mode, params)
          .then(res => {
            if (res.code == "1") {
              let text = this.mode == "add" ? "添加成功" : "编辑成功";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch(err => {
            console.log(err);
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
    validate() {
      let _this = this;
      var param =
        this.baseData.paymentType == "zz"
          ? this.baseData.amount == "" ||
            this.baseData.bankAccount == "" ||
            this.baseData.collectingCompany == "" ||
            this.baseData.depositBank == "" ||
            this.baseData.paymentType == "" ||
            this.baseData.reason == ""
          : this.baseData.amount == "" ||
            this.baseData.collectingCompany == "" ||
            this.baseData.paymentType == "" ||
            this.baseData.reason == "";
      if (param) {
        _this.$toast("请完善表单信息");
        return false;
      }
      return true;
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.paymentPage {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
    }
  }
  .editBtnbox.btnBox {
    .btn {
      width: 100%;
    }
    .btn:first-child {
      // background-color: #f34646;
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin: 10px 0 45px 0;
  }
}
</style>
